import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  LabelList,
  Rectangle,
  ResponsiveContainer
} from "recharts";
import { useState, useEffect } from "react";
import { handleClickLogic } from "../../utils/filterFunctions";
import "./Charts.css";

const BarChartSummary = ({ resumenData, xKey = "name", diferencia, variacion, tittle = "Resumen general", selectedKey, frozenKey, onBarClick }) => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [isFrozen, setIsFrozen] = useState(false);
  const [frozenData, setFrozenData] = useState(null);

  const dataToRender = isFrozen ? frozenData : resumenData;

  useEffect(() => {
    setSelectedCategory(selectedKey);
  }, [selectedKey]);

  useEffect(() => {
    if (frozenKey !== tittle) {
      setIsFrozen(false);
      setFrozenData(null);
    }
  }, [frozenKey, tittle]);

  const hasData = Array.isArray(dataToRender) && dataToRender.length > 0 && diferencia !== null && variacion !== null && diferencia !== undefined && variacion !== undefined;

  if (!hasData) {
    return (
      <div className="chart-card">
        <h3>{tittle}</h3>
        <div className="chart-body empty">
          <p style={{ textAlign: "center", color: "#888", margin: "20px 0" }}>
            Sin datos disponibles
          </p>
        </div>
      </div>
    );
  }

  const colors = ['#00BFFF', '#FFA500'];
  const barKeys = Object.keys(dataToRender[0]).filter(key => key !== xKey);

  const handleBarClick = (data) => {
    handleClickLogic({
      data,
      xKey,
      selectedCategory,
      isFrozen,
      showData: resumenData,
      setIsFrozen,
      setFrozenData,
      setSelectedCategory,
      onBarClick,
    });
  };

  return (
    <div className="chart-card">
      <h3>{tittle}</h3>
      <div className="metric-summary" style={{ display: "flex", justifyContent: "space-around", marginBottom: 15 }}>
        <div>Diferencia: {diferencia}</div>
        <div>Variación: {variacion}%</div>
      </div>
      <div className="chart-body">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={dataToRender}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey={xKey} />
            <YAxis />

            <Bar
              dataKey={(entry) => {
                const year = entry.name;
                const value = entry[year];
                return value === 0 ? null : value;
              }}

              fill={(entry) => {
                const year = entry.name;
                const index = barKeys.indexOf(String(year));
                return colors[index];
              }}

              onClick={handleBarClick}
              isAnimationActive={false}

              shape={(props) => {
                if (props.value == null) return null;

                const category = props.payload?.[xKey];
                const year = props.payload?.name;
                const colorIndex = barKeys.indexOf(String(year));
                const fillColor = colors[colorIndex % colors.length];
                const isSelected = selectedCategory === category;

                const opacity = isFrozen
                  ? selectedCategory && !isSelected ? 0.4 : 1
                  : 1;

                const stroke = isFrozen && isSelected ? "#333" : "none";
                const strokeWidth = isFrozen && isSelected ? 2 : 0;

                return (
                  <Rectangle
                    {...props}
                    fill={fillColor}
                    fillOpacity={opacity}
                    stroke={stroke}
                    strokeWidth={strokeWidth}
                    cursor="pointer"
                  />
                );
              }}
            >
              <LabelList
                position="top"
                formatter={(v) => (v == null ? "" : v)}
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export default BarChartSummary;
